'use strict'

// A sample component

const Scroll = {
    init: function () {
        Scroll.html = document.querySelector('html');
        Scroll.body = document.querySelector('body');
        Scroll.lastScroll = 0;

        Scroll.bloc = document.querySelector('.c-residence_button_candidate');
        Scroll.logo = document.querySelector('.c-menu_sticky_container_link');
        Scroll.images = document.querySelector('.c-dynamiqueImage_image');

        window.addEventListener("scroll", Scroll.checkScroll);
    },

    checkScroll: function (e) {
        var currentScroll = Math.max(Scroll.html.scrollTop, Scroll.body.scrollTop)

        if (Scroll.bloc) {
            if (Scroll.html.scrollTop > currentScroll) {
                Scroll.bloc.classList.add("c-residence_button_candidate--selected");
            } else {
                Scroll.bloc.classList.remove("c-residence_button_candidate--selected");
            }
        }

        if (Scroll.logo) {
            if (currentScroll < Scroll.lastScroll) {
                Scroll.logo.classList.add("c-menu_sticky_container_link--selected");
            } else {
                Scroll.logo.classList.remove("c-menu_sticky_container_link--selected");
            }
        }

        if (Scroll.images) {
            let items = Scroll.images.querySelectorAll(".c-dynamiqueImage_defaultImageStyle");
            let step = window.innerHeight / items.length;
            let currentItem = parseInt(currentScroll / step) % items.length;
            for (var i = 0; i < items.length; i++) {
                items[i].style.zIndex = (i === currentItem ? 1 : 0)
            }
        }

        Scroll.lastScroll = currentScroll;
    }
}


export default Scroll;


// WEBPACK FOOTER //
// ./src/scripts/components/Scroll.js